module.exports = __webpack_public_path__ + "pic/11.a82a5856.png";